export enum HandlingstypEnum {
  BilagaAnsökan = 54,
  CV_CurriculumVitae = 62,
  Projektbeskrivning_Bidragsärenden = 113,
  Projektpartsgodkännande = 302,
  BilagaLägesrapport = 44,
  BilagaSlutrapport = 51,
  BilagaEfterrapport = 228,
  BilagaStartrapport = 284,
  Bilaga = 53,
  BilagaBegäran = 312,
}

export function getHandlingstypName(value: number): string | undefined {
  const entry = Object.entries(HandlingstypEnum).find(([, v]) => v === value);
  return entry ? entry[0] : undefined;
}
